import React from 'react'

function invoice() {
  return (
    <p>invoice</p>
  )
}

export default invoice